import React, { useEffect, useState } from "react";
import { Tooltip, Button, Box, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { useTooltip } from "./TooltipContext";

const TooltipMarker = ({ targetKey, message, placement = "top", classes, onNext, onClose }) => {
  const { targets } = useTooltip();
  const targetRef = targets[targetKey]; // Get the correct ref from context
  const [coords, setCoords] = useState(null);
  const [open, setOpen] = useState(true); // Control tooltip visibility

  useEffect(() => {
    if (!targetRef) return;

    const updateCoords = () => {
      if (!targetRef) return;

      const rect = targetRef.getBoundingClientRect();
      setCoords({
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
      });
    };

    updateCoords(); // Set initial position
    window.addEventListener("resize", updateCoords);
    window.addEventListener("scroll", updateCoords);

    return () => {
      window.removeEventListener("resize", updateCoords);
      window.removeEventListener("scroll", updateCoords);
    };
  }, [targetRef]);

  if (!coords) return null; // Don't render tooltip until we have coordinates

  const { top, left, width, height } = coords;

  // ✅ Dynamically position tooltip relative to the targetRef
  let finalTop = top;
  let finalLeft = left;

  const color = '#1B1920';

  const tooltipStyles = {
    position: "fixed", // ✅ FIX: Ensures tooltip is placed relative to viewport, not wrapper div
    background: color,//"#fff",
    padding: "4px 8px",
    borderRadius: "8px",
    color: '#fff',
    opacity: 0.95,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
  };

  const arrowStyles = {
    position: "absolute",
    width: 0,
    height: 0,
    borderStyle: "solid",
  };

  switch (placement) {
    case "top":
      finalTop = top - 50;
      finalLeft = left + width / 2;
      tooltipStyles.transform = "translateX(-50%)";
      Object.assign(arrowStyles, {
        top: "100%",
        left: "50%",
        borderWidth: "10px 10px 0 10px",
        borderColor: `${color} transparent transparent transparent`,
        transform: "translateX(-50%)",
      });
      break;
    case "bottom":
      finalTop = top + height + 10;
      finalLeft = left + width / 2;
      tooltipStyles.transform = "translateX(-50%)";
      Object.assign(arrowStyles, {
        bottom: "100%",
        left: "50%",
        borderWidth: "0 10px 10px 10px",
        borderColor: `transparent transparent ${color} transparent`,
        transform: "translateX(-50%)",
      });
      break;
    case "left":
      finalTop = top + height / 2;
      finalLeft = left - 210;
      tooltipStyles.transform = "translateY(-50%)";
      Object.assign(arrowStyles, {
        top: "50%",
        right: "-10px",
        borderWidth: "10px 0 10px 10px",
        borderColor: `transparent transparent transparent ${color}`,
        transform: "translateY(-50%)",
      });
      break;
    case "right":
      finalTop = top + height / 2;
      finalLeft = left + width + 10;
      tooltipStyles.transform = "translateY(-50%)";
      Object.assign(arrowStyles, {
        top: "50%",
        left: "-10px",
        borderWidth: "10px 10px 10px 0",
        borderColor: `transparent ${color} transparent transparent`,
        transform: "translateY(-50%)",
      });
      break;
    default:
      break;
  }

  return (
    <Tooltip open={open} title="">
      <Box style={{ ...tooltipStyles, top: finalTop, left: finalLeft }}>
        <div style={arrowStyles}></div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>{message}</span>
          <IconButton edge="end" color="inherit" onClick={() => onClose(targetKey)} aria-label="close" sx={{ backgroundColor: color }}>
            <CloseIcon style={{ fontSize: 14, color: '#fff' }} />
          </IconButton>
        </div>
        {/* <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setOpen(false);
            if (onNext) onNext(); // Move to next tooltip
          }}
        >
          Next
        </Button> */}
      </Box>
    </Tooltip>
  );
};

export default TooltipMarker;
